export default __webpack_public_path__ + "static/media/2.22ff36ca.JPG";